var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getDialogVisible
    ? _c("div", { staticClass: "custom-dialog" }, [
        _c("div", { staticClass: "nullBox" }),
        _c("div", { staticClass: "warp" }, [
          _c(
            "div",
            {
              ref: "dialogBodyRef",
              class: {
                "custom-dialog-body": true,
                "full-screen": _vm.isFullScreen(),
                "slide-screen": !_vm.isFullScreen(),
              },
              style: { "padding-bottom": _vm.isFullScreen() ? "0" : "0" },
            },
            [
              _c("div", { staticClass: "custom-dialog-head" }, [
                _c("div", { staticClass: "head-info" }, [
                  _c(
                    "div",
                    {
                      staticClass: "head-img",
                      style: {
                        background: !!_vm.getInfo.icon
                          ? ""
                          : _vm.getInfo.backgroundColor,
                        color: !!_vm.getInfo.icon ? "" : _vm.getInfo.textColor,
                      },
                    },
                    [
                      _vm.getInfo.icon
                        ? _c("img", {
                            attrs: { src: _vm.getInfo.icon, alt: "" },
                          })
                        : _c("span", [
                            _vm._v(" " + _vm._s(_vm.getInfo.headerTitle)),
                          ]),
                    ]
                  ),
                  _c("div", [
                    _c("div", { staticClass: "head-title" }, [
                      _vm._v(" " + _vm._s(_vm.getInfo.title) + " "),
                    ]),
                    _c("div", { staticClass: "head-describe" }, [
                      _vm._v(" " + _vm._s(_vm.getInfo.describe) + " "),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: { height: "100%", "padding-top": "18px" },
                    on: { mousedown: _vm.handleKeyup },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-close close",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  class: {
                    "custom-dialog-content": true,
                    "custom-dialog-content-full": _vm.isFullScreen(),
                    "custom-dialog-content-slide": !_vm.isFullScreen(),
                  },
                  on: { mousedown: _vm.handleKeyup },
                },
                _vm._l(_vm.componentList, function (item, i) {
                  return _c(
                    item.name,
                    _vm._b(
                      {
                        key: i + "custom-component",
                        tag: "component",
                        attrs: { type: item.type, rows: 1 },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      },
                      "component",
                      item.props,
                      false
                    )
                  )
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "bottom-btn",
                  on: { mousedown: _vm.handleKeyup },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-send",
                      style: { width: _vm.isFullScreen() ? "95.2%" : "86.8%" },
                      on: { click: _vm.send },
                    },
                    [_vm._v("发送")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }